import Link from '../../containers/home/Link';

export default Link;